<div class="c-text c-text--gd g--margin-t-15"> 
    <span>{{"precliente.formulario.label.observaciones"|translate}}</span>
    <textarea type="text" class="textarea g--margin-t-15 g--height-100-px" id="IdObservacion" maxlength="100"
        name="OBSERVACIONES" #IdObservacion (input)="actualizarContador(IdObservacion.value)"  [(ngModel)]="textareaValue">
    </textarea>
    <div id="contador">{{ contador }}</div>
</div>